import * as React from 'react';
export class Article extends React.Component {
    constructor(props) {
        super(props);
        this.handleArticleClick = this.handleArticleClick.bind(this);
    }
    render() {
        const { article } = this.props;
        return (React.createElement("li", { className: "article", onClick: this.handleArticleClick, key: `list-key-${article.id}`, id: `list-id-${article.id}` },
            React.createElement("a", { className: "article__article-link", id: `anchor-id-${article.id}`, key: `anchor-key-${article.id}` }, article.title)));
    }
    handleArticleClick() {
        const { article } = this.props;
        return this.props.goToArticle(article.id);
    }
}
export default { Article };
